import request from './request'

// 获取类型
export function getVehicleType (params) {
  return request.get('/largescreen/vehicle/getVehicleType', params).then(res => res);
}

export function point (params) {
  return request.post('/largescreen/vehicle/point', params).then(res => res);
}
export function getVehicleNumber (params) {
  return request.get('/largescreen/vehicle/getVehicleNumber', params).then(res => res);
}
export function getDrcCountByType (params) {
  return request.get('/largescreen/vehicle/getDrcCountByType', params).then(res => res);
}
export function getNeighborDrcNumber (params) {
  return request.get('/largescreen/vehicle/getNeighborDrcNumber', params).then(res => res);
}
export function getOnlineList (params) {
  return request.get('/largescreen/vehicle/getOnlineList', params).then(res => res);
}
export function getVehicleInfoByDrcId (params) {
  return request.get('/largescreen/vehicle/getVehicleInfoByDrcId', params).then(res => res);
}
export function getVehicleInfoByVehicleId (params) {
  return request.get('/largescreen/vehicle/getVehicleInfoByVehicleIdV1', params).then(res => res);
}
export function getUserArea(params) {
  return request.get('/largescreen/vehicle/getUserArea', params).then(res => res);
}

export function getOnlineListByType(params) {
  return request.get('/largescreen/vehicle/getOnlineListByType', params).then(res => res);
}
export function getMaxVnumByArea(params) {
  return request.get('/largescreen/vehicle/getMaxVnumByArea', params).then(res => res);
}
export function getOtherVehicleCode(params) {
  return request.get('/largescreen/vehicle/getOtherVehicleCode', params).then(res => res);
}
export function getAreaVehicleNumByType(params) {
  return request.get('/largescreen/vehicle/getAreaVehicleNumByType', params).then(res => res);
}
// 查询乡镇补贴列表
export function getAreaAllowanceList(params) {
  return request.get('/largescreen/job/getAreaAllowanceList', params).then(res => res);
}
// 智能农机本市内跨区数量
export function getCrossRegionInAreaCount(params) {
  return request.get('/largescreen/vehicle/getCrossRegionInAreaCount', params).then(res => res);
}
// 智能农机邻县区跨区数量
export function getCrossRegionNeighborCount(params) {
  return request.get('/largescreen/vehicle/getCrossRegionNeighborCount', params).then(res => res);
}
// 月度智能农机上线数量
export function getOnLineCountByMonth(params) {
  return request.get('/largescreen/vehicle/getOnLineCountByMonth', params).then(res => res);
}

// 获取字典
export function getDictData(dict) {
  return request.get(`/largescreen/job/type/${dict}`, ).then(res => res);
}

// 大屏用户点位列表（省、市、县）
export function getUserPointList(params) {
  return request.get('/largescreen/vehicle/getUserPointList', params).then(res => res);
}

// 大屏机手详情（省、市、县）
export function getUserVehicleInfo(params) {
  return request.get('/largescreen/vehicle/getUserVehicleInfo', params).then(res => res);
}
// 可联系农机、机手定位
export function getUserAndVehiclePointList (params) {
  return request.get('/largescreen/vehicle/getUserAndVehiclePointList', params).then(res => res);
}

// 各区域农机数量（按定位区域聚合数量）
export function getAreaCount(params) {
  return request.get('/largescreen/vehicle/getAreaCount', params).then(res => res);
}

// 兼容接口直接返回数组，以及 data、rows、list、records 等常见包装格式
function getScreenPointData(result) {
  const resultData = result && result.data;
  const candidates = [
    result,
    resultData,
    result && result.rows,
    result && result.list,
    result && result.records,
    resultData && resultData.rows,
    resultData && resultData.list,
    resultData && resultData.records,
  ];
  return candidates.find(item => Array.isArray(item)) || [];
}

// 屏幕点位数据量可能较大，单次遍历完成坐标校验和类型标记
function normalizeScreenPointList(result, pointType) {
  return getScreenPointData(result).reduce((list, point) => {
    if (!point) return list;
    const longitudeValue = point.longitude != null
      ? point.longitude
      : point.lng != null
        ? point.lng
        : point.lon;
    const latitudeValue = point.latitude != null ? point.latitude : point.lat;
    const longitude = Number(longitudeValue);
    const latitude = Number(latitudeValue);
    if (
      longitudeValue == null ||
      latitudeValue == null ||
      String(longitudeValue).trim() === '' ||
      String(latitudeValue).trim() === '' ||
      !Number.isFinite(longitude) ||
      !Number.isFinite(latitude) ||
      longitude < -180 ||
      longitude > 180 ||
      latitude < -90 ||
      latitude > 90
    ) {
      return list;
    }
    point.longitude = longitude;
    point.latitude = latitude;
    point.personOrVehicle = pointType;
    list.push(point);
    return list;
  }, []);
}

// 查询当前地图屏幕内机手点位列表
export function getUserPointListByScreen(params) {
  return request.post('/largescreen/vehicle/getUserPointListByScreen', params)
    .then(res => normalizeScreenPointList(res, 'user'));
}

// 查询当前地图屏幕内农机点位列表
export function getVehiclePointListByScreen(params) {
  return request.post('/largescreen/vehicle/getVehiclePointListByScreen', params)
    .then(res => normalizeScreenPointList(res, 'vehicle'));
}

// 查询指定半径范围内农机点位列表
export function getVehiclePointListByRadius (params) {
  return request.post('/largescreen/vehicle/getVehiclePointListByRadius', params).then(res => res);
}

// 查询指定半径范围内机手点位列表
export function getUserPointListByRadius (params) {
  return request.post('/largescreen/vehicle/getUserPointListByRadius', params).then(res => res);
}
